import { IPromoDetails } from '../../types/promos/promoDetails';
import { TPromoSchema } from '../../types/searchResponse';

export const mapPromosDetails = (promo: TPromoSchema): IPromoDetails => {
  return {
    // @ts-expect-error TODO: Удалить в CD-203170
    newbuildingListingUrlDesktop: promo.promoPopup.newbuildingListingUrlDesktop,
    // @ts-expect-error TODO: Удалить в CD-203170
    newbuildingListingUrlMobile: promo.promoPopup.newbuildingListingUrlMobile,
    // @ts-expect-error TODO: Удалить в CD-203170
    builders: promo.promoPopup.builders,
    // @ts-expect-error TODO: Удалить в CD-203170
    actionName: promo.promoPopup.actionName || null,
    banks: promo.promoPopup.banks,
    // @ts-expect-error TODO: Убрать директиву в CD-203170
    isNewbuildingCountTextLinkable: promo.promoPopup.isNewbuildingCountTextLinkable,
    // @ts-expect-error TODO: Убрать директиву в CD-203170
    newbuildingCountText: promo.promoPopup.newbuildingCountText,
    // @ts-expect-error TODO: Убрать директиву в CD-203170, оставив лишь второе условие
    newbuildingIds: promo.promoPopup.newbuildingIds || promo.newbuildingIds,
    // @ts-expect-error TODO: Убрать директиву в CD-203170
    newbuildingLinks: promo.promoPopup.newbuildingLinks,
    promoDescription: promo.promoPopup.promoDescription || null,
    // @ts-expect-error TODO: Убрать директиву в CD-203170, оставив лишь второе условие
    promoName: promo.promoPopup.promoName || promo.promoName,
    // @ts-expect-error TODO: Убрать директиву в CD-203170, оставив лишь первое условие
    promoProps: promo.promoProps || promo.promoPopup.promoProps,
    promoType: promo.promoType,
    // @ts-expect-error TODO: Убрать директиву в CD-203170, оставив второе условие
    providerLogo: promo.promoPopup.providerLogo || promo.providerLogo,
    providerName: promo.providerName,
  };
};
